// @flow

import React from "react";

import { Checkbox as StyledCheckbox } from "src/styles/input.old";

type Props = {
  id: string,
  checked?: boolean,
  children?: any,
  handleChange?: Function
};

const Checkbox = ({
  id,
  checked = false,
  children = null,
  handleChange = () => {}
}: Props) => (
  <StyledCheckbox data-cy="checkboxContainer">
    <label htmlFor={id}>
      <input
        data-cy="checkbox"
        type="checkbox"
        onChange={handleChange}
        checked={checked}
        id={id}
      />
      <div />
      <span>{children}</span>
    </label>
  </StyledCheckbox>
);

export default Checkbox;
